/* global System */

import withLazyUnveil from 'scripts/higher-order-components/withLazyUnveil'

export default {
  RegionLocationAgents: withLazyUnveil({
    loadComponent: () =>
      System.import(/* webpackChunkName: "RegionLocationAgents" */ './index'),
    height: 445,
    mobileHeight: 622,
  }),
}
